import { mapGetters } from "vuex";
import { CommonHelper } from "../helpers";
import SuperProjection from "../models/superProjection";
import {
  projectionType,
  IceRowType,
  ACTION_EOM,
  DATETYPE,
  EntityTypes,
  SuperFundType,
  PensionOptionType,
  AdvanceSuperFilter,
  WithdrawalIndex,
  AdvanceSubtype,
} from "../helpers/constant";
import {
  GET_CLIENT_INFORMATION,
  SET_ICE_PROJECTION_MODEL,
} from "../helpers/vuex-constants";
import { mapActions } from "vuex";
import BaseIceIntegration from "./ice-integration";

export default {
  mixins: [BaseIceIntegration],
  computed: {
    ...mapGetters({
      ClientsInfo: GET_CLIENT_INFORMATION,
    }),
  },
  methods: {
    ...mapActions("super", {
      setSuperIceProjectionModel: SET_ICE_PROJECTION_MODEL,
    }),
    prepareAPIModel(baselineData) {
      let inputClientData = this.prepareBaseAPIModel();
      const isPartnerPresent = inputClientData.PartnerInfo.Id ? true : false;
      inputClientData.ClientInfo.RetirementAge = this.getRetirementAge(
        baselineData[0].ownerDetails,
        inputClientData.ClientInfo.Id
      );
      inputClientData.PartnerInfo.RetirementAge = this.getRetirementAge(
        baselineData[0].ownerDetails,
        inputClientData.PartnerInfo.Id
      );
      let isClientRetired = true;
      // CommonHelper.getRetirementDate(
      //   inputClientData.ClientInfo.DOB,
      //   inputClientData.ClientInfo.RetirementAge
      // ) < new Date()
      //   ? true
      //   : false;
      let isPartnerRetired = true;
      // CommonHelper.getRetirementDate(
      //   inputClientData.PartnerInfo.DOB,
      //   inputClientData.PartnerInfo.RetirementAge
      // ) < new Date()
      //   ? true
      //   : false;
      inputClientData.ProjectionInfo = this.fillSuperProjectionData(
        baselineData,
        inputClientData.ClientInfo.Id,
        isClientRetired,
        isPartnerRetired,
        isPartnerPresent
      );
      return inputClientData;
    },

    getRetirementAge(superOtherDetail, clientId) {
      let retirementAge = 0;
      if (superOtherDetail.length > 0) {
        for (let i = 0; i < superOtherDetail.length; i++) {
          if (superOtherDetail[i].clientId == clientId) {
            retirementAge = superOtherDetail[i].retirementAge;
          }
        }
      }
      return retirementAge;
    },

    getTotalBalaceOfFund(superfundDetails, clientId, fundType) {
      let amount = 0;
      if (superfundDetails) {
        let fundInfo = superfundDetails.filter(
          (sr) => sr.clientId == clientId && sr.fundtype == fundType
        );
        if (fundInfo.length > 0) {
          for (let i = 0; i < fundInfo.length; i++) {
            if (fundInfo[i].isIncludeContribution) {
              amount = amount + fundInfo[i].superFundBalance;
            }
          }
        }
      }
      return amount;
    },

    fillSuperProjectionData(
      baselineData,
      clientId,
      isClientRetired,
      isPartnerRetired,
      isPartnerPresent
    ) {
      let superInfo = [];

      //SuperFundData
      for (let i = 0; i < baselineData.length; i++) {
        superInfo = superInfo.concat(
          this.fillSuperClientData(
            baselineData[i],
            clientId,
            baselineData[i].referenceGuid,
            isClientRetired,
            isPartnerRetired
          )
        );
      }
      // Income
      for (let i = 0; i < baselineData.length; i++) {
        superInfo = superInfo.concat(
          this.fillSuperClientIncomeData(
            baselineData[i],
            clientId,
            baselineData[i].referenceGuid
          )
        );
      }
      // Income
      for (let i = 0; i < baselineData.length; i++) {
        superInfo = superInfo.concat(
          this.fillSuperExpenseClientIncomeData(
            baselineData[i],
            baselineData[i].referenceGuid,
            isPartnerPresent
          )
        );
      }
      //Other
      for (let i = 0; i < baselineData.length; i++) {
        superInfo = superInfo.concat(
          this.fillSuperClientOtherDetails(
            baselineData[i],
            baselineData[i].referenceGuid,
            isPartnerPresent
          )
        );
      }
      // Non Super
      for (let i = 0; i < baselineData.length; i++) {
        superInfo = superInfo.concat(
          this.fillSuperClientNonSuperData(baselineData[i], isPartnerPresent)
        );
      }

      //superAddtionalDetails

      return superInfo;
    },
    fillSuperAddtionalDetails(superAddtionalDetails, clientId, typeId) {
      let superData = [];
      if (superAddtionalDetails) {
        for (let i = 0; i < superAddtionalDetails.length; i++) {
          let superfundObj = this.getFundDetailsFromAdvanceObject(
            superAddtionalDetails[i]
          );

          if (
            AdvanceSuperFilter.Accumulation == superfundObj.typeId &&
            typeId == AdvanceSuperFilter.Accumulation &&
            clientId == superfundObj.clientId
          ) {
            superData = superData.concat(
              this.getSuperReturn(
                superfundObj,
                superfundObj.startType,
                superfundObj.endType,
                "",
                0,
                0,
                superfundObj.startDate,
                superfundObj.EndDate,
                false
              )
            );
          }
          if (
            AdvanceSuperFilter.Pension == superfundObj.typeId &&
            typeId == AdvanceSuperFilter.Pension &&
            clientId == superfundObj.clientId
          ) {
            superData = superData.concat(
              this.getPensionReturn(
                superfundObj,
                superfundObj.startType,
                superfundObj.endType,
                "",
                0,
                0,
                superfundObj.startDate,
                superfundObj.EndDate,
                false
              )
            );
          }
          if (
            (((AdvanceSuperFilter.Contribution == superfundObj.typeId ||
              AdvanceSuperFilter.WithdrawalAccumulation ==
                superfundObj.typeId) &&
              typeId == AdvanceSuperFilter.Accumulation) ||
              (AdvanceSuperFilter.WithdrawalPension == superfundObj.typeId &&
                typeId == AdvanceSuperFilter.Pension)) &&
            clientId == superfundObj.clientId
          ) {
            let type = this.getAdvanceFilterType(superfundObj);
            superData = superData.concat(
              this.getIceRowForSuperModel(
                type,
                superfundObj.startType,
                superfundObj.subTypeId == AdvanceSubtype.Repayment.LumpSum
                  ? 0
                  : superfundObj.endType,
                superfundObj.amount,
                superfundObj.subTypeId == AdvanceSubtype.Repayment.LumpSum
                  ? 7
                  : superfundObj.frequency,

                superfundObj.index,
                (type == IceRowType.Non_Concessional ||
                  type == IceRowType.Salary_Sacrifice ||
                  type == IceRowType.Employer_Amount ||
                  type == IceRowType.Super_Out_Reg ||
                  type == IceRowType.Super_Pension_Reg) &&
                  superfundObj.effectiveAsOn == 0
                  ? ACTION_EOM
                  : superfundObj.effectiveAsOn,
                superfundObj.startDate,
                superfundObj.EndDate,
                false
              )
            );
          }

          if (
            AdvanceSuperFilter.PensionPayment == superfundObj.typeId &&
            typeId == AdvanceSuperFilter.PensionPayment &&
            clientId == superfundObj.clientId
          ) {
            const pensionType = this.getPensionType(superfundObj.superTypeId);
            const amount = this.getPensionAmount(
              superfundObj.superTypeId,
              superfundObj.amount
            );
            superData = superData.concat(
              this.getPensionAmountReturn(
                pensionType,
                amount,
                superfundObj.startType,
                superfundObj.subTypeId == AdvanceSubtype.Repayment.LumpSum
                  ? 0
                  : superfundObj.endType,

                superfundObj.subTypeId == AdvanceSubtype.Repayment.LumpSum
                  ? 7
                  : superfundObj.frequency,

                superfundObj.index,
                superfundObj.effectiveAsOn,
                superfundObj.startDate,
                superfundObj.EndDate,
                false
              )
            );
          }
        }
      }
      return superData;
    },
    fillSuperAddtionalMarketPlaceDetails(superAddtionalDetails) {
      let superData = [];
      if (superAddtionalDetails) {
        for (let i = 0; i < superAddtionalDetails.length; i++) {
          let superfundObj = this.getFundDetailsFromAdvanceObject(
            superAddtionalDetails[i]
          );

          if (AdvanceSuperFilter.MarketCrash == superfundObj.typeId) {
            for (let i = 0; i < 2; i++) {
              superData = superData.concat(
                this.getIceRowForSuperModel(
                  i == 0
                    ? IceRowType.Super_MarketDrop
                    : IceRowType.Super_MarketDropRecoveryPercent,
                  superfundObj.startType,
                  superfundObj.endType,
                  i == 0 ? superfundObj.amount : superfundObj.growthRate,
                  superfundObj.frequency,
                  superfundObj.index,
                  superfundObj.effectiveAsOn,
                  superfundObj.startDate,
                  superfundObj.EndDate,
                  false
                )
              );
            }
          }
        }
      }
      return superData;
    },
    getAdvanceFilterType(superfundObj) {
      let isRegular =
        superfundObj.subTypeId == AdvanceSubtype.Repayment.Regular
          ? true
          : false;
      if (superfundObj.typeId == AdvanceSuperFilter.Contribution) {
        if (superfundObj.superTypeId == WithdrawalIndex.CONTRIBUTION) {
          return isRegular
            ? IceRowType.Employer_Amount
            : IceRowType.Employer_LS_Amount;
        } else if (
          superfundObj.superTypeId == WithdrawalIndex.SALARYSACRIFICE
        ) {
          return isRegular
            ? IceRowType.Salary_Sacrifice
            : IceRowType.Salary_LS_Sacrifice;
        } else if (
          superfundObj.superTypeId == WithdrawalIndex.NONCONCESSIONAL
        ) {
          return isRegular
            ? IceRowType.Non_Concessional
            : IceRowType.Non_LS_Concessional;
        }
      } else if (
        superfundObj.typeId == AdvanceSuperFilter.WithdrawalAccumulation
      ) {
        if (superfundObj.subTypeId == AdvanceSubtype.Repayment.Regular) {
          return IceRowType.Super_Out_Reg;
        } else {
          return IceRowType.Super_Out_LS;
        }
      } else if (superfundObj.typeId == AdvanceSuperFilter.WithdrawalPension) {
        if (superfundObj.subTypeId == AdvanceSubtype.Repayment.Regular) {
          return IceRowType.Super_Pension_Reg;
        } else {
          return IceRowType.Super_Pension_LS;
        }
      }
      return 0;
    },
    getFundDetailsFromAdvanceObject(fundDetail) {
      let obj = {
        startType: CommonHelper.defaulAdvanceIntValue(fundDetail.startDateType),

        endType: CommonHelper.defaulAdvanceIntValue(fundDetail.endDateType),
        startDate: CommonHelper.defaulAdvanceDateValue(fundDetail.startDate),
        EndDate: CommonHelper.defaulAdvanceDateValue(fundDetail.endDate),
        incomeRate: CommonHelper.defaulAdvanceIntValue(fundDetail.amount1),
        growthRate: CommonHelper.defaulAdvanceIntValue(fundDetail.amount2),
        frankingRate: CommonHelper.defaulAdvanceIntValue(fundDetail.amount3),
        amount: CommonHelper.defaulAdvanceIntValue(fundDetail.amount1),
        clientId: CommonHelper.defaulAdvanceIntValue(fundDetail.clientID),
        frequency: CommonHelper.defaulAdvanceIntValue(fundDetail.frequency),
        effectiveAsOn: CommonHelper.defaulAdvanceIntValue(
          fundDetail.effectiveAsOn
        ),
        index: CommonHelper.defaulAdvanceIntValue(fundDetail.index),
        typeId: CommonHelper.defaulAdvanceIntValue(fundDetail.typeId),
        subTypeId: CommonHelper.defaulAdvanceIntValue(fundDetail.subTypeId),
        superTypeId: CommonHelper.defaulAdvanceIntValue(fundDetail.superTypeId),
      };
      if (obj.startType == 0) {
        obj.startType = DATETYPE.Other;
      }
      if (obj.endType == 0) {
        obj.endType = DATETYPE.Other;
      }
      return obj;
    },
    fillSuperExpenseClientIncomeData(
      formModel,
      referenceGuid,
      isPartnerPresent
    ) {
      let superData = [];

      let superRow = {};
      superRow.UniqueId = referenceGuid;
      superRow.ProjectionType = projectionType.SuperIncome;
      superRow.EntityType = isPartnerPresent
        ? EntityTypes.both
        : EntityTypes.client;
      superRow.Projections = [];
      superRow.Projections.push(
        this.getIceRowForSuperModel(
          IceRowType.Retire_Expense,
          DATETYPE.Client_Retirement,
          DATETYPE.Max,
          formModel.otherDetail.retirementExpenseBalance,
          1,
          2
        )
      );

      superData.push(superRow);

      return superData;
    },
    fillSuperClientIncomeData(formModel, clientId, refrerenceId) {
      let superData = [];
      for (let i = 0; i < formModel.ownerDetails.length; i++) {
        let superRow = {};
        superRow.UniqueId = refrerenceId;
        superRow.ProjectionType = projectionType.SuperIncome;
        superRow.EntityType =
          clientId == formModel.ownerDetails[i].clientId
            ? EntityTypes.client
            : EntityTypes.partner;
        superRow.Projections = this.fillSuperIncomeData(
          formModel.ownerDetails[i],
          superRow.EntityType
        );

        superData.push(superRow);
      }
      return superData;
    },
    fillSuperIncomeData(ownerDetail, entityType) {
      let Projections = [];
      let row = this.getIceRowForSuperModel(
        IceRowType.Income_Employment_Reg,
        DATETYPE.Start,
        entityType == EntityTypes.client
          ? DATETYPE.Client_Retirement
          : DATETYPE.Partner_Retirement,
        ownerDetail.totalIncome,
        1,
        1,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
      Projections.push(row);
      return Projections;
    },
    fillSuperClientOtherDetails(formModel, referenceGuid, isPartnerPresent) {
      let superData = [];

      let superRow = {};
      superRow.UniqueId = referenceGuid;
      superRow.ProjectionType = projectionType.SuperAgePension;
      superRow.EntityType = isPartnerPresent
        ? EntityTypes.both
        : EntityTypes.client;

      superRow.Projections = this.fillSuperOtherDetails(formModel.otherDetail);
      superRow.Projections = superRow.Projections.concat(
        this.fillSuperAddtionalMarketPlaceDetails(
          formModel.superAddtionalDetails
        )
      );

      superData.push(superRow);

      return superData;
    },

    fillSuperOtherDetails(otherDetail) {
      let Projections = [];
      let row = {};
      if (otherDetail.isAgePension) {
        row = this.getIceRowForSuperModel(
          IceRowType.Age_Pension,
          DATETYPE.Start,
          DATETYPE.Max,
          1
        );
        Projections.push(row);
      }
      if (otherDetail.isHomeOwner) {
        row = this.getIceRowForSuperModel(
          IceRowType.Home_Owner,
          DATETYPE.Start,
          DATETYPE.Max,
          1
        );
        Projections.push(row);
      }

      return Projections;
    },
    fillSuperClientNonSuperData(formModel, isPartnerPresent) {
      let superData = [];

      let superRow = {};
      superRow.UniqueId = CommonHelper.uuidv4();
      superRow.ProjectionType = projectionType.Investemnt;
      superRow.EntityType = isPartnerPresent
        ? EntityTypes.both
        : EntityTypes.client;
      superRow.IsNotIncludeInOutput = true;
      superRow.Projections = this.fillSuperNonSuperData(formModel.nonSuperData);

      superData.push(superRow);

      return superData;
    },

    fillSuperClientData(
      formModel,
      clientId,
      UniqueId,
      isClientRetired,
      isPartnerRetired
    ) {
      let superData = [];

      for (let i = 0; i < formModel.fundDetails.length; i++) {
        let superRow = {};
        let amount = this.getTotalBalaceOfFund(
          formModel.superfundDetails,
          formModel.fundDetails[i].clientId,
          formModel.fundDetails[i].fundType
        );
        superRow.UniqueId = CommonHelper.uuidv4();
        superRow.RefrerenceId = UniqueId;
        superRow.ProjectionType =
          formModel.fundDetails[i].fundType == SuperFundType.Pension
            ? projectionType.Pension
            : projectionType.Accumulation;

        superRow.EntityType =
          clientId == formModel.fundDetails[i].clientId
            ? EntityTypes.client
            : EntityTypes.partner;
        superRow.Projections = this.fillSuperFundDetails(
          formModel.fundDetails[i],
          superRow.EntityType,
          superRow.UniqueId,
          formModel.fundDetails[i].clientId,
          amount,
          formModel.superAddtionalDetails
        );

        let row = {};
        if (
          isClientRetired &&
          clientId == formModel.fundDetails[i].clientId &&
          formModel.fundDetails[i].fundType == SuperFundType.Accumulation
        ) {
          row = this.getIceRowForSuperModel(
            IceRowType.rollout,
            DATETYPE.Client_Retirement,
            0,
            0,
            7,
            3,
            0
          );
          superRow.Projections = superRow.Projections.concat(row);
        }
        if (
          isPartnerRetired &&
          clientId != formModel.fundDetails[i].clientId &&
          formModel.fundDetails[i].fundType == SuperFundType.Accumulation
        ) {
          row = this.getIceRowForSuperModel(
            IceRowType.rollout,
            DATETYPE.Partner_Retirement,
            0,
            0,
            7,
            3,
            0
          );
          superRow.Projections = superRow.Projections.concat(row);
        }
        superData.push(superRow);
      }

      return superData;
    },
    fillSuperNonSuperData(nonSuperData) {
      let Projections = [];

      for (let i = 0; i < nonSuperData.length; i++) {
        let row = this.getIceRowForSuperModel(
          IceRowType.Investment_Balance,
          DATETYPE.Start,
          DATETYPE.Max,
          nonSuperData[i].currentValue
        );
        Projections.push(row);
        row = this.getIceRowForSuperModel(
          IceRowType.Investment_Income_Rate,
          DATETYPE.Start,
          DATETYPE.Max,
          nonSuperData[i].incomeReturn
        );
        Projections.push(row);
        row = this.getIceRowForSuperModel(
          IceRowType.Investment_Growth_Rate,
          DATETYPE.Start,
          DATETYPE.Max,
          nonSuperData[i].growthReturn
        );
        Projections.push(row);
        row = this.getIceRowForSuperModel(
          IceRowType.Investment_Franking_Rate,
          DATETYPE.Start,
          DATETYPE.Max,
          0
        );
        Projections.push(row);
        row = this.getIceRowForSuperModel(
          IceRowType.Investment_DRP,
          DATETYPE.Start,
          DATETYPE.Max,
          0
        );
        Projections.push(row);
        row = this.getIceRowForSuperModel(
          IceRowType.Investment_In_Reg,
          DATETYPE.Start,
          DATETYPE.Max,
          nonSuperData[i].contribution
        );
        Projections.push(row);
      }
      return Projections;
    },
    fillSuperFundDetails(
      fundDetail,
      entityType,
      uniqueId,
      clientId,
      amount,
      superAddtionalDetails
    ) {
      let Projections = [];

      if (fundDetail.fundType == SuperFundType.Pension) {
        Projections = Projections.concat(
          this.fillSuperPensionReturn(fundDetail, entityType, amount)
        );
        Projections = Projections.concat(
          this.fillSuperPensionAmount(fundDetail, uniqueId, entityType)
        );
        Projections = Projections.concat(
          this.fillSuperAddtionalDetails(
            superAddtionalDetails,
            clientId,
            AdvanceSuperFilter.Pension
          )
        );
        Projections = Projections.concat(
          this.fillSuperAddtionalDetails(
            superAddtionalDetails,
            clientId,
            AdvanceSuperFilter.PensionPayment,
            entityType
          )
        );
      } else {
        Projections = Projections.concat(
          this.fillSuperReturn(fundDetail, entityType, amount)
        );
        Projections = Projections.concat(
          this.fillSuperAddtionalDetails(
            superAddtionalDetails,
            clientId,
            AdvanceSuperFilter.Accumulation
          )
        );
        Projections = Projections.concat(
          this.fillSuperContributionAmount(fundDetail, uniqueId, entityType)
        );
      }
      return Projections;
    },
    fillSuperContributionAmount(fundDetail, uniqueId, entityType) {
      let Projections = [];
      if (fundDetail.contribution.isUseSGC) {
        Projections = Projections.concat(
          this.getContributionFieldIceModel(
            IceRowType.Use_SGC,
            "",
            "",
            1,
            uniqueId,
            entityType,
            2
          )
        );
      }
      Projections = Projections.concat(
        this.getContributionFieldIceModel(
          IceRowType.Employer_Amount,
          fundDetail.contribution.employerDurationType,
          fundDetail.contribution.employerGrowthType,
          fundDetail.contribution.employerAmount,
          uniqueId,
          entityType,
          ACTION_EOM
        )
      );
      Projections = Projections.concat(
        this.getContributionFieldIceModel(
          IceRowType.Non_Concessional,
          fundDetail.contribution.nonConcessionalDurationType,
          fundDetail.contribution.nonConcessionalGrowthType,
          fundDetail.contribution.nonConcessionalAmount,
          uniqueId,
          entityType,
          ACTION_EOM
        )
      );
      Projections = Projections.concat(
        this.getContributionFieldIceModel(
          IceRowType.Salary_Sacrifice,
          fundDetail.contribution.salarySacrificeDurationType,
          fundDetail.contribution.salarySacrificeGrowthType,
          fundDetail.contribution.salarySacrificeAmount,
          uniqueId,
          entityType,
          ACTION_EOM
        )
      );

      return Projections;
    },

    getContributionFieldIceModel(
      type,
      frequency,
      index,
      amount,
      uniqueId,
      entityType,
      EffectiveAsOn
    ) {
      let Projections = [];

      let row = {};
      row = this.getIceRowForSuperModel(
        type,
        DATETYPE.Start,
        entityType == EntityTypes.client
          ? DATETYPE.Client_Retirement
          : DATETYPE.Partner_Retirement,
        amount,

        frequency,
        index,
        EffectiveAsOn
      );
      Projections.push(row);
      return Projections;
    },
    getPensionType(typeId) {
      if (typeId == PensionOptionType.Minimum) {
        return IceRowType.Pension_Option_Min;
      } else if (typeId == PensionOptionType.Other) {
        return IceRowType.Pension_Option_Other;
      } else {
        return IceRowType.Pension_Option_Optimise;
      }
    },
    getPensionAmount(typeId, amount) {
      if (
        typeId == PensionOptionType.Minimum ||
        typeId == PensionOptionType.Optimise
      ) {
        return 1;
      } else {
        return amount;
      }
    },
    fillSuperPensionAmount(fundDetail, uniqueId, entityType) {
      const pensionType = fundDetail.pensionPayment.paymentType;
      let row = {};
      const Projections = [];
      if (pensionType > 0) {
        row = this.getIceRowForSuperModel(
          pensionType == PensionOptionType.Minimum
            ? IceRowType.Pension_Option_Min
            : pensionType == PensionOptionType.Other
            ? IceRowType.Pension_Option_Other
            : IceRowType.Pension_Option_Optimise,

          entityType == EntityTypes.client
            ? DATETYPE.Client_Retirement
            : DATETYPE.Partner_Retirement,
          DATETYPE.Max,

          pensionType == PensionOptionType.Minimum
            ? 1
            : pensionType == PensionOptionType.Other
            ? fundDetail.pensionPayment.amount
            : 1,
          fundDetail.pensionPayment.durationType,
          fundDetail.pensionPayment.growthType
        );
      }
      Projections.push(row);
      return Projections;
    },
    getPensionAmountReturn(
      iceRowType,
      amount,
      startType,
      endType,
      frequency,
      index,
      EffectiveAsOn,
      startDate,
      endDate,
      isBaseLineField
    ) {
      let superReturn = [];
      let row = this.getIceRowForSuperModel(
        iceRowType,
        startType,
        endType,
        amount,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      return superReturn;
    },

    getSuperReturn(
      fundDetail,
      startType,
      endType,
      frequency,
      index,
      EffectiveAsOn,
      startDate,
      endDate,
      isBaseLineField
    ) {
      let superReturn = [];
      let row = {};
      row = this.getIceRowForSuperModel(
        IceRowType.SuperAccumulation_Interest_Rate,
        startType,
        endType,
        fundDetail.incomeRate,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      row = this.getIceRowForSuperModel(
        IceRowType.SuperAccumulation_Growth_Rate,
        startType,
        endType,
        fundDetail.growthRate,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      row = this.getIceRowForSuperModel(
        IceRowType.SuperAccumulation_Franking_Rate,
        startType,
        endType,
        fundDetail.frankingRate,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      return superReturn;
    },
    fillSuperReturn(fundDetail, entityType, amount) {
      let Projections = [];

      let row = {};
      row = this.getIceRowForSuperModel(
        IceRowType.superBalance,
        DATETYPE.Start,
        DATETYPE.Max,
        amount
      );
      Projections.push(row);
      Projections = Projections.concat(
        this.getSuperReturn(
          fundDetail,
          DATETYPE.Start,
          entityType == EntityTypes.client
            ? DATETYPE.Client_Retirement
            : DATETYPE.Partner_Retirement
        )
      );
      return Projections;
    },

    getPensionReturn(
      fundDetail,
      startType,
      endType,
      frequency,
      index,
      EffectiveAsOn,
      startDate,
      endDate,
      isBaseLineField
    ) {
      let superReturn = [];
      let row = {};
      row = this.getIceRowForSuperModel(
        IceRowType.Pension_Interest_Rate,
        startType,
        endType,
        fundDetail.incomeRate,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      row = this.getIceRowForSuperModel(
        IceRowType.Pension_Growth_Rate,
        startType,
        endType,
        fundDetail.growthRate,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      row = this.getIceRowForSuperModel(
        IceRowType.Pension_Franking_Rate,
        startType,
        endType,
        fundDetail.frankingRate,
        frequency ? frequency : 0,
        index ? index : 0,
        EffectiveAsOn ? EffectiveAsOn : 0,
        startDate ? startDate : "",
        endDate ? endDate : "",
        isBaseLineField != undefined ? isBaseLineField : true
      );
      superReturn.push(row);
      return superReturn;
    },
    fillSuperPensionReturn(fundDetail, entityType, amount) {
      let Projections = [];

      let row = {};
      row = this.getIceRowForSuperModel(
        IceRowType.superPension,
        DATETYPE.Start,
        DATETYPE.Max,
        amount
      );
      Projections.push(row);
      Projections = Projections.concat(
        this.getPensionReturn(
          fundDetail,
          entityType == EntityTypes.client
            ? DATETYPE.Client_Retirement
            : DATETYPE.Partner_Retirement,
          DATETYPE.Max
        )
      );
      return Projections;
    },
    getIceRowForSuperModel(
      iceType,
      startType,
      EndType,
      amount,
      frequency,
      index,
      EffectiveAsOn,
      startDate,
      endDate,
      IsBaseLineField,
      isTaxable
    ) {
      let row = {};
      row.Type = iceType;
      row.StartType = startType;
      row.Start = startDate ? startDate : "";
      row.EndType = EndType;
      row.END = endDate ? endDate : "";
      row.Frequency = frequency ? frequency : 0;
      row.Amount = iceType == IceRowType.Super_MarketDrop ? -amount : amount;
      row.AccountNumber = "";
      row.EffectiveAsOn =
        iceType == IceRowType.Pension_Option_Min ||
        iceType == IceRowType.Pension_Option_Other ||
        iceType == IceRowType.Pension_Option_Optimise
          ? 2
          : EffectiveAsOn
          ? EffectiveAsOn
          : 0;
      row.Description = "";
      row.Indexation = index ? index : 0;
      row.IsBaseLineField =
        IsBaseLineField != undefined ? IsBaseLineField : true;
      row.IsTaxable = isTaxable ? isTaxable : false;
      return row;
    },

    setSuperModel(projectionData) {
      let reponseData = {
        currentBalance: CommonHelper.convertIntoCurrencyWithoutDecimal(
          projectionData.superProjectionResult[0].totalCurrentBalance
        ),
        RetirementBalance: CommonHelper.convertIntoCurrencyWithoutDecimal(
          projectionData.superProjectionResult[0].RetirementBalance
        ),
        BalanceRunOutAt: projectionData.superProjectionResult[0].BalanceRunOutAt
          ? projectionData.superProjectionResult[0].BalanceRunOutAt
          : "-",
        superContributionWithdrawalGraphData:
          SuperProjection.getSuperContributionWithdrawalGraphData(
            projectionData.superProjectionResult[0].superProjection,
            projectionData.incomeExpense[0].superProjection
          ),
        incomeExpenseGraphData: SuperProjection.getincomeExpenseGraphData(
          projectionData.incomeExpense[0].superProjection
        ),
        superBalanceGraphData: SuperProjection.getSuperBalanceGraphData(
          projectionData.superProjectionResult[0].superProjection,

          projectionData.incomeExpense[0].superProjection
        ),
        superReturnFeesGraphData: SuperProjection.getSuperReturnFeesGraphData(
          projectionData.superProjectionResult[0].superProjection,

          projectionData.incomeExpense[0].superProjection
        ),
      };
      return reponseData;
    },
  },
};
